{
  "MOBILE": {
    "ONBOARDING": {
      "NEXT_BUTTON": "Next",
      "PREVIOUS_BUTTON": "Précédent",
      "FINISH_BUTTON": "Finish"
    },
    "LOGIN": {
      "EMAIL_PLACEHOLDER": "Email",
      "PASSWORD_PLACEHOLDER": "Mot de passe",
      "ERROR_MESSAGE": "Could not login. Please try again",
      "ERROR_COMPLETE_FIELDS": "Please complete the fields above.",
      "FORGOT_PASSWORD": "Forgot password?",
      "LOGIN_BUTTON": "J'ai termine"
    },
    "FORGOT_PASSWORD": {
      "EMAIL_PLACEHOLDER": "Email",
      "ERROR_EMAIL": "Email is mandatory",
      "ERROR_COMPLETE_FIELDS": "Please complete the fields above.",
      "SEND_BUTTON": "Send a reset link",
      "BACK_BUTTON": "Go back to login",
      "MODAL_BACK_BUTTON": "Take me to Login",
      "CHECK_EMAIL": "Please check your email for the activation link"
    },
    "REGISTER": {
      "NAME_PLACEHOLDER": "Name",
      "COMPANY_PLACEHOLDER": "Company code",
      "EMAIL_PLACEHOLDER": "Email",
      "PASSWORD_PLACEHOLDER": "Mot de passe",
      "ERROR_FIELDS": "At least 5 characters, 1 lower case letter, 1 upper case letter and a number.",
      "ERROR_MESSAGE": "Could not register. Please try again",
      "ERROR_COMPLETE_FIELDS_TERMS": "Please complete the fields above or agree to the terms",
      "ERROR_COMPLETE_FIELDS": "Please complete the fields above.",
      "AGREE_WITH": "I agree with the",
      "TERMS_CONDITIONS": "terms and conditions",
      "CREATE_BUTTON": "Creer mon compte",
      "CHECK_EMAIL": "Please check your email for the activation link",
      "GO_TO_LOGN": "Take me to Login"
    },
    "DASHBOARD": {
      "GREETINGS": "Bonjour",
      "LOADING": "Loading data..",
      "WENT_WRONG": "Something went wrong",
      "STEPS_MADE": "steps realises",
      "SURVEY_BUTTON_TITLE": "N’oubliez pas de faire votre moodchek",
      "THEME_LIST_TITLE": "Thematique en cours",
      "NO_THEME": "Add exercise to dashboard to see which themes you have active",
      "GO_TO_THEMES": "Take me to Themes",
      "NO_EXERCISE": "Add exercises from followed paths to see it here",
      "CHOOSE_NEW_PATH": "Choisir un nouveau parcours"
    },
    "THEMES": {
      "ERROR": "Something went wrong",
      "TITLE": "Themes",
      "RECOMMENDED_TITLE": "Recommande pour vous",
      "MODULES": "modules"
    },
    "THEME_DETAILS": {
      "ERROR": "Something went wrong"
    },
    "PATH": {
      "CONGRATULATIONS": "Congratulations on finishing this path. We hope you feel better.",
      "BACK_DASHBOARD": "Bring me back to my dashboard",
      "START_PATH": "Start a new path",
      "PAUSE_PATH": "Ne plus suivre",
      "MINUTES_LABEL": "minutes",
      "CHOSE_OTHER_PATH": "Please choose another path",
      "RESUME": "Resume",
      "START": "Commencer",
      "FINISH": "Finish Path",
      "SWITCH_PATH_TITLE": "Faire de ce parcours votre parcours actif ?",
      "SWITCH_PATH_MESSAGE": "Votre liste du jour suit un seul parcours à la fois. Passer à celui-ci ?",
      "SWITCH_PATH_CONFIRM": "Oui, changer",
      "SWITCH_PATH_CANCEL": "Pas maintenant"
    },
    "BUTTON": {
      "FINISH": "J'ai termine",
      "COMPLETED": "Completed",
      "ADD_TO_DASHBOARD": "Ajouter a ma page d'accueil",
      "NEXT": "Suivant"
    },
    "SETTINGS": {
      "TITLE": "Paramètres",
      "NAVIGATION_TITLE": "Paramètres",
      "MY_HEALTH": "Ma Santé",
      "HEALTH_DASHBOARD_ERROR": "Impossible de charger le tableau de bord santé. Veuillez réessayer plus tard.",
      "LOADING": "Chargement...",
      "RETRY": "Réessayer"
    },
    "HEALTH": {
      "NAVIGATION_TITLE": "Santé",
      "NO_FACE_SCAN_MESSAGE": "Complétez votre premier scan facial pour voir votre tableau de bord santé",
      "START_FACE_SCAN_BUTTON": "Démarrer le Scan Facial"
    },
    "CHALLENGE": {
      "TITLE": "Défi",
      "MAKE_IT_ROUTINE": "Intégrons-le à votre routine !",
      "FOR_A_WEEK": "Pendant une semaine",
      "FOR_X_DAYS": "Pendant {{numberOfDays}} jours",
      "ADD_TO_MY_PROGRAM": "Ajouter à mon programme",
      "MAYBE_LATER": "Peut-être plus tard",
      "ADDED_TO_PROGRAM": "Ajouté à mon programme",
      "IN_PROGRESS": "Défi en cours",
      "KEEP_IT_UP": "Vous êtes sur la bonne voie, continuez ! 💪",
      "START_AUDIO": "Commencer à méditer 🧘",
      "START_JOURNALING": "Remplir mon journal",
      "SEE_MEMO": "Voir le mémo 📖",
      "PREVIOUS_ENTRIES": "Mes entrées précédentes",
      "DAY": "Jour",
      "GREAT_START": "C'est bien parti, à demain ! 👋",
      "GREAT_JOB": "Un jour de plus accompli, bravo ! 👏",
      "ALL_DONE": "Défi terminé 🎉",
      "CONGRATULATIONS": "Félicitations 👏",
      "ONE_STEP_CLOSER": "Vous êtes allé(e) au bout de ce défi. À vous maintenant d'en faire une habitude !",
      "MAKE_IT_REAL": "Transformons votre intention en habitude !",
      "REMINDER_HELPS": "Ajouter un rappel vous aide à atteindre vos objectifs.",
      "ACTIVATE_REMINDERS": "Activer les rappels",
      "SCHEDULE": "Heure",
      "CALENDAR_HINT": "Sur le web, Evoluno ne peut pas envoyer de notifications : ajoutez plutôt le rappel quotidien à votre agenda.",
      "ADD_TO_GOOGLE_CALENDAR": "Ajouter à Google Agenda",
      "ADD_TO_CALENDAR": "Télécharger pour Apple Calendrier ou Outlook (.ics)",
      "CALENDAR_ADDED": "Rappel ajouté à votre agenda. Si un fichier a été téléchargé, ouvrez-le pour confirmer.",
      "ALL_SET_UP": "Je suis prêt(e) !",
      "UPDATE_ENTRY": "Modifier",
      "SUMMARY_TAB": "Résumé",
      "CALENDAR_TAB": "Calendrier",
      "WEEK_OF": "Semaine du",
      "COMPLETE_TODAY": "Compléter aujourd’hui",
      "SETTINGS_TITLE": "Paramètres du défi",
      "SAVE": "Enregistrer",
      "STOP_CHALLENGE": "Arrêter le défi",
      "NO_ENTRY_YET": "Pas encore d'entrée",
      "FREE_ENTRY": "Entrée libre",
      "START_NEW_CHALLENGE": "Commencer un nouveau défi",
      "REMOVE_FROM_CHALLENGES": "Retirer de mes défis quotidiens",
      "DONE_TODAY": "Déjà complété aujourd’hui ✓",
      "SKIPPED_FOR_NOW": "Passé pour l’instant. Vous pouvez toujours l’ajouter à votre routine."
    },
    "DIARY": {
      "FEELING_TITLE": "Qu’est-ce qui décrit le mieux ce ressenti ?",
      "KEYWORDS_TITLE": "Votre journée en quelques mots-clés :",
      "FEELING_JOYFUL": "Joyeux(se)",
      "FEELING_CONFIDENT": "Confiant(e)",
      "FEELING_GRATEFUL": "Reconnaissant(e)",
      "FEELING_SURPRISED": "Surpris(e)",
      "FEELING_AMUSED": "Amusé(e)",
      "FEELING_EXCITED": "Enthousiaste",
      "FEELING_CALM": "Calme",
      "FEELING_TIRED": "Fatigué(e)",
      "FEELING_STRESSED": "Stressé(e)",
      "FEELING_SAD": "Triste",
      "FEELING_ANGRY": "En colère",
      "FEELING_ANXIOUS": "Anxieux(se)",
      "KEYWORD_FRIENDS": "Amis 🧑‍🤝‍🧑",
      "KEYWORD_COOKING": "Cuisine 🍳",
      "KEYWORD_CHORES": "Tâches ménagères 🧹",
      "KEYWORD_STUDIES": "Études 🎓",
      "KEYWORD_FAMILY": "Famille 👨‍👩‍👧",
      "KEYWORD_GAMES": "Jeux 🎮",
      "KEYWORD_READING": "Lecture 📖",
      "KEYWORD_OUTINGS": "Loisirs et sorties 🎡",
      "KEYWORD_MUSIC": "Musique 🎶",
      "KEYWORD_SHOPPING": "Shopping 🛍️",
      "KEYWORD_SPORTS": "Sport 🏃",
      "KEYWORD_WORK": "Travail 💼",
      "KEYWORD_RELAXATION": "Détente 🧘",
      "KEYWORD_NATURE": "Nature 🌿",
      "KEYWORD_TRAVEL": "Voyages ✈️",
      "BEDTIME": "Heure du coucher",
      "TIME_TO_FALL_ASLEEP": "Temps d’endormissement",
      "WAKE_UP_TIME": "Heure de réveil",
      "NIGHTTIME_AWAKENINGS": "Réveils nocturnes",
      "EXTRA_DETAILS": "Ajoutez d’autres détails (facultatif)",
      "WHAT_ELSE_TITLE": "Que puis-je ajouter d’autre ?",
      "WHAT_ELSE_BODY": "Tout peut compter : ce que vous avez mangé ou bu le soir, si vous avez pris de l’alcool ou de la caféine dans la journée, ce dont vous avez rêvé pendant la nuit..."
    }
  },
  "SIDEBAR": {
    "USERS": "Users",
    "CATEGORIES": "Categories",
    "MENU": "MENU",
    "ADMINISTRATOR": "ADMINISTRATOR",
    "LABELS": "Labels",
    "THEMES": "Themes",
    "THEME": "THEME",
    "CONTENT": "Content",
    "EXERCICES": "Exercices",
    "DASHBOARD": "Dashboard",
    "STATIC_PAGES": "Static pages",
    "BLOG": "BLOG",
    "CUSTOMERS": "Customers",
    "PATHS": "Paths",
    "MANAGE_DATA": "Manage Data",
    "DATA_REPORT": "Data report",
    "STATIC_CONTENT": "Static content",
    "GENERAL_SETTINGS": "General settings",
    "PHARMACIES": "Pharmacies",
    "ROLES": "User Roles",
    "TAGS": "Tags",
    "ADMIN": "ADMIN",
    "COMPANIES": "Companies",
    "SURVEY": "Surveys",
    "QUESTION": "Questions",
    "FEATURE": "Features"
  },
  "USER_PROFILE": {
    "DIALOG": {
      "FIRST_NAME": "First name",
      "EMAIL": "Email",
      "ROLE": "Role",
      "EDIT_PROFILE": "Edit profile",
      "LAST_NAME": "Last name"
    }
  },
  "LIST_USERS": {
    "USERS_DIALOG": {
      "UPDATE_USER": "Update user",
      "ROLE": "Role",
      "PREFERRED_LANGUAGE": "Preferred language",
      "ERRORS": {
        "EMAIL": {
          "EMAIL_INVALID": "Email is not valid",
          "EMAIL_REQUIRED": "Email is required"
        },
        "FIRSTNAME_REQUIRED": "First Name is required",
        "ZIP_CODES_REQUIRED": "Zip Codes are required",
        "LASTNAME_REQUIRED": "Last Name is required",
        "COMPANY_REQUIRED": "Please select a company",
        "PHONE_REQUIRED": "Phone is required"
      },
      "LAST_NAME": "Last Name",
      "ACTIVE": "Active",
      "EMAIL": "Email",
      "PHONE": "Phone",
      "CREATE_USER": "Create user",
      "PASSWORD": "Password",
      "PUSH_TOKEN_ID": "Push Token Id",
      "FIRST_NAME": "First Name",
      "CLIENT": "Client",
      "COMPANY": "Company"
    }
  },
  "LIST_ROLES": {
    "ROLE_DIALOG": {
      "UPDATE_ROLE": "Update role",
      "TOOLTIP": {
        "REMOVE_PERMISSION": "Remove permission"
      },
      "DESCRIPTION": "Description",
      "ERRORS": {
        "DESCRIPTION_REQUIRED": "Description is required",
        "PERMISSION_REQUIRED": "Please select a permission",
        "NAME_REQUIRED": "Name is required"
      },
      "ADD_PERMISSION": "Add a permission",
      "CREATE_ROLE": "Create role",
      "COLOR": "Color",
      "NAME": "Name"
    },
    "INFORMATION_DIALOG": {
      "BODY": "The following users currently have this role:",
      "TITLE": "Please make sure the role is not in use before you try to delete it."
    }
  },
  "LIST_CATEGORIES": {
    "CATEGORY_DIALOG": {
      "COLOR": "Color",
      "ERRORS": {
        "DEFAULT_REQUIRED": "Default value is required",
        "NAME_REQUIRED": "Name is required"
      },
      "CREATE_CATEGORY": "Create category",
      "UPDATE_CATEGORY": "Update category",
      "NAME": "Name",
      "VALUE": "Value"
    }
  },
  "LIST_TAGS": {
    "TAG_DIALOG": {
      "ICON_PATH": "Icon",
      "GENERAL_INFO": "General information",
      "TYPE": "Type",
      "TYPES": {
        "TAG_TYPE": "Tag"
      },
      "LABEL": "Tags",
      "PUBLISHED": "Published"
    }
  },
  "LIST_STATIC_PAGES": {
    "STATIC_PAGES_DIALOG": {
      "CONTENT": "Content",
      "UPDATE_STATIC_PAGE": "Update static page",
      "ERRORS": {
        "DUPLICATE_LINK_ERROR": "Page name already exist. Choose another name",
        "TITLE_REQUIRED": "Title is required",
        "CONTENT_REQUIRED": "Content is required"
      },
      "CREATE_STATIC_PAGE": "Create static page",
      "TITLE": "Title",
      "LINK": "Link: "
    }
  },
  "LIST_STATIC_CONTENT": {
    "STATIC_CONTENT_DIALOG": {
      "UPDATE_STATIC_CONTENT": "Update static content",
      "NAME": "Name",
      "CREATE_STATIC_CONTENT": "Create static content"
    }
  },
  "LANGUAGE_PICKER": {
    "ADD_TRANSLATION": "Add translation",
    "TABLE": {
      "EDIT": "Edit",
      "TERM": "Term",
      "DELETE": "Delete",
      "LANGUAGE": "Language"
    },
    "CURRENT_LANGUAGE": "Current language",
    "AVAILABLE_TRANSLATIONS": "Available translations"
  },
  "FILTERS": {
    "PLACEHOLDERS": {
      "SEARCH": "Search"
    }
  },
  "BUTTONS": {
    "CREATE": "Create",
    "EDIT": "Edit",
    "BLOCK": "Blocked",
    "SAVE_AS_DRAFT": "Save as draft",
    "RESET": "Reset",
    "REMOVE": "Remove",
    "CONFIRM_DELETE": "Yes, delete it",
    "UNBLOCK_USER": "Unblock user",
    "GO_TO_ARTICLE": "Go to article",
    "OK": "Ok",
    "ACTIVATE": "Activate",
    "CONFIRM_KEEP": "No, keep it",
    "UNBLOCK": "UNBLOCK",
    "COPY_DEFAULT_LANGUAGE": "Copy {{ defaultLanguage }} content",
    "CANCEL": "Cancel",
    "CLOSE": "Close",
    "SAVE": "Save",
    "REPORT": "Report",
    "APPLY": "Apply",
    "UPDATE": "Update",
    "DELETE": "Delete",
    "BLOCK_USER": "Block User",
    "PREVIEW": "Preview"
  },
  "AUTH": {
    "LOGIN": {
      "LABEL_OR": "OR",
      "PROVIDERS": {
        "FACEBOOK": "Login with Facebook",
        "GOOGLE": "Login with Google",
        "OFFICE365": "Login with Office 365"
      },
      "CREATE_ACCOUNT": "Create an acoount.",
      "ALT_IMAGES": {
        "GOOGLE_ICON": "google icon",
        "FACEBOOK_ICON": "facebook icon",
        "OFFICE_ICON": "office 365 icon"
      },
      "REMEMBER_ME": "Remember me",
      "LOGIN_BTTN": "LOGIN to Evoluno",
      "FORGOT_PASS": "Forgot password?",
      "NO_ACCOUNT": "Don't have an account?"
    },
    "REGISTER": {
      "TERMS_CONDITIONS": "I agree with the <a href=\"{{ link }}\" target=\"_blank\">terms and conditions</a>",
      "REGISTER_BTN": "CREATE AN ACCOUNT",
      "ALREADY_REGISTERED": "Already have an account?",
      "TO_LOGIN": "Login",
      "TITLE": "CREATE AN ACCOUNT"
    },
    "ACTIVATE": {
      "TITLE": "ACTIVATE YOUR ACCOUNT",
      "RESEND_CODE": "Send me another code",
      "CODE_RESENT": "Another activation code has been sent at \"{{ email }}\"",
      "BACK": "Back to account creation"
    },
    "RESET_PASSWORD": {
      "ACTION": "SAVE NEW PASSWORD",
      "TITLE": "CHANGE YOUR PASSWORD",
      "REDIRECT_LOGIN": "Go back to login"
    },
    "VALIDATIONS": {
      "NAME_REQUIRED": "Name is required",
      "USER_BLOCKED": "User is blocked",
      "RESET_CODE_REQUIRED": "Reset code sent to your email is required",
      "NO_LENGTH": "Password should contain at least 5 characters. \n",
      "PASSWORD_NO_LENGTH": "At least 5 characters.",
      "LAST_NAME_REQUIRED": "Last name is required",
      "PASS_INVALID": "Password is not strong enough.",
      "NO_UPPERCASE": "Password should contain at least one upper case letter. \n",
      "PASSWORD_NO_UPPERCASE": "At least one upper case letter.",
      "EMAIL_REQUIRED": "Email is required.",
      "PASS_MUST_MATCH": "Passwords must match",
      "NO_LOWERCASE": "Password should contain at least one lower case letter. \n",
      "PASSWORD_NO_LOWERCASE": "At least one lower case letter.",
      "EMAIL_INVALID": "Oups, this doesn't look like a valid email address.",
      "ACTIVATION_CODE_REQUIRED": "Activation code is required",
      "NO_NUMBER": "Password should contain at least one number. \n",
      "PASSWORD_NO_NUMBER": "At least one number.",
      "FIRST_NAME_REQUIRED": "First name is required",
      "PASS_REQUIRED": "Password is required.",
      "PASS_STRENGTH_INFO": "Min 5 characters,\n one uppercase,\n one lowercase and one number",
      "PASSWORD_SHOULD_CONTAIN": "Password should contain:"
    },
    "PLACEHOLDERS": {
      "PASS_CONFIRMATION": "Password (Confirm)",
      "NEW_PASSWORD": "New Password",
      "PASS": "Password",
      "RESET_CODE": "Reset code",
      "FIRST_NAME": "First Name",
      "REMEMBER_ME": "Remember Me",
      "LAST_NAME": "Last Name",
      "READ_AND_ACCEPT": "I read and accept",
      "EMAIL": "Email",
      "ACTIVATION_CODE": "Enter activation code recieved by email"
    },
    "EMAIL": {
      "ACTIVATE_ACTION": "Activate my account",
      "ACTIVATE_TITLE": "One last step to access Evoluno",
      "ACTIVATE_BODY": "To activate your account click on the button below to activate your account!",
      "ACTIVATE_EMAIL_LABEL": "Email",
      "RECOVER_BODY": "Did you forget your password? It happens to the best of us!\n Use this code to change your password:"
    },
    "TABS": {
      "REGISTER": "Register",
      "LOGIN": "Login"
    },
    "FORGOT_PASSWORD": {
      "TITLE": "CHANGE YOUR PASSWORD",
      "ACTION": "SEND RESET LINK",
      "REDIRECT_LOGIN": "Go back to login"
    },
    "TOOLTIP_ALL_FIELDS_REQUIRED": "All fields are required"
  },
  "NAVBAR": {
    "INBOX": "Inbox",
    "ADMIN": "Admin",
    "LOGIN": "Login",
    "BACK_TO_HOME": "Back to home",
    "ALT_IMAGES": {
      "LANGUAGE_SWITCHER": "language flag"
    },
    "MY_PROFILE": "My Profile",
    "LOGOUT": "Logout"
  },
  "HEADER": {
    "TEXTS": {
      "HEADER_SUBTITLE": "A website created by awesome people for awesome people.",
      "HEADER_TITLE": "WELCOME TO EVOLUNO"
    },
    "BUTTONS": {
      "MONGO": "Mongo",
      "WEB": "Web",
      "IOS": "IOS",
      "ANDROID": "Android",
      "STATIC": {
        "ABOUT_US": "About us"
      },
      "ANGULAR": "Angular",
      "FIREBASE": "Firebase",
      "NODE": "Node"
    }
  },
  "FEED_LIST": {
    "MORE": "View more",
    "SHARE_ARTICLE": "shared an article with you",
    "NO_FEED": "There are no articles under this category."
  },
  "BANNER": {
    "INVALID_EMAIL_OR_PASSWORD": "Oops, email & password you provided do not match. Check them again or create a new account",
    "RESET_CODE_SENT": "We just sent you a reset link at {{ email }}. Check your inbox !",
    "ACCOUNT_CREATED": "Account created!",
    "ALL_FIELDS_ARE_REQUIRED": "All fields are required!",
    "PATH_PUBLISHED": "Path was published",
    "LOGIN_SUCCESS": "Welcome {{ name }} !",
    "PASSWORD_RESET_ERROR": "Oups, we don't know your email {{ email }} yet or bad reset code. Check it again, or create an account.",
    "ACCOUNT_DEACTIVATED": "Account deactivated! ({{email}})",
    "SESSION_EXPIRED": "Your session expired. In order to access the application you have to login",
    "FREE_BAGS_WERE_PARKED_ERROR": "Free bags parking error",
    "PATH_UNPUBLISHED": "Path was unpublished",
    "LOGOUT_SUCCESS": "You've been logged out successfully!",
    "REGISTER_SUCCESS": "Nice to meet you, {{ firstName }} {{ lastName }} ! Check your inbox to get your activation code.",
    "ACOUNT_DEACTIVATION_ERROR": "Account deactivation error ({{email}})",
    "WARNING_EXPIRE": "Your session will expire in {{ bufferTimeMin }} minutes.\n      <a\n        id=\"{{ refreshTokenElementSelector }}\"\n        style=\"margin-left: 10px; color: white; text-decoration: underline; cursor: pointer\">Are you still online?\n      </a>",
    "FREE_BAGS_PERIOD_WAS_CLOSED": "Free Bags Period was Closed",
    "ERROR_UNPUBLISHING_PATH": "An error produced while unpublishing the path",
    "USER_BLOCKED": "User has been blocked",
    "REGISTER_ERROR": " {{ email }} already exists in the database",
    "ACOUNT_NOT_ACTIVATED": "Oups, double check unique code. Account not activated!!!",
    "PROFILE_IMAGE_SUCCES": "You have successfully changed your avatar!",
    "FREE_BAGS_PERIOD_WAS_CLOSED_ERROR": "Free Bags Period Closing Error",
    "PASSWORD_RESET_SUCCESS": "Your password has been reset successfully!",
    "ACCOUNT_ACTIVATED": "Account activated! Welcome {{ email }} !",
    "ACCOUNT_NOT_CREATED": "Oups, an error has occured, account was not created!",
    "FREE_BAGS_WERE_PARKED": "Free bags parked: all referred scans were parked for client {{ client }}",
    "ERROR_PUBLISHING_PATH": "An error produced while publishing the path",
    "STEP_MOVED_UP": "Step moved up",
    "STEP_MOVED_DOWN": "Step moved down",
    "ERROR_MOVING_STEP_DOWN": "Error moving step down",
    "ERROR_MOVING_STEP_UP": "Error moving step up"
  },
  "ERROR": {
    "403": {
      "CODE": "403",
      "MESSAGE_1": "Bad password"
    },
    "404": {
      "CODE": "404",
      "MESSAGE_1": "Sorry but we could not find the page you are looking for.",
      "MESSAGE_2": "We're sorry for the inconvenience."
    },
    "500": {
      "CODE": "500",
      "MESSAGE_2": "looks like we have an internal issue, please try again in couple minutes.",
      "MESSAGE_1": "Well, you broke the internet!"
    },
    "503": {
      "MESSAGE_2": "We're sorry for the inconvenience.",
      "CODE": "503",
      "MESSAGE_1": "Closed for scheduled maintenance!"
    },
    "AUTH_ERROR": {
      "PASSWORD_COULD_NOT_BE_RESET": "The password could not be reset",
      "NOT_INSTANCE_OF_USER": "Cannot login user, because an instance of user not provided",
      "BLOCKED_USER": "User is blocked",
      "RECAPTCHA_ERROR": "Something went wrong with reCaptcha",
      "COMPANY_OF_USER_NOT_FOUND": "Company of user not found",
      "NO_DEFAULT_ROLE": "There is no default role set up!",
      "EMAIL_ALREADY_EXISTS": "Oups, an account with email {{ email }} already exists.",
      "ERROR_LOGGING_IN": "Error logging in",
      "PASSWORD_SHOULD_DIFFER": "The new password should differ form the last password",
      "EMAIL_CLIENT_ID_MISMATCH": "The email and the client ID don't match",
      "EMAIL_IN_USE": "You already activated that account. Try to login instead, or recover you password.",
      "PASSWORD_RESET_NO_USER": "User does not exist",
      "COMPANY_SUBSCRIPTION_NOT_ACTIVE": "Company Subscription not active"
    },
    "CRUD": {
      "RETRIEVE": "Items couldn't be retrieved",
      "DELETE": "Item couldn't be deleted",
      "RETRIEVE_ONE_NO_ID": "No ID was provided for retrieve action",
      "ITEM_META": "Item info couldn't be retrieved",
      "CREATE": "Item couldn't be created",
      "UPDATE": "Item couldn't be updated",
      "RETRIEVE_ONE": "Can't retrieve item with the ID: {{ item_id }} , {{ constructor_name }}",
      "PRODUCT_TYPE": {
        "CAN_NOT_DELETE_SCAN_DEPENDENCIES": "Can't be deleted as there are scans that reference this product type"
      }
    },
    "OTHER_ERRORS": {
      "COMPARISON_NOT_IMPLEMENTED": "Comparison operation {{ operation }} is not implemented!",
      "LANGUAGE_NOT_SUPPORTED": "Language is not supported!",
      "AN_ERROR_OCCURED": "An error occured"
    },
    "PATH": {
      "ERROR_DELETING_PATH": "There was an error deleting the path",
      "ERROR_UNPUBLISHING_PATH": "There was an error unpublishing the path",
      "ERROR_PUBLISHING_PATH": "There was an error publishing the path",
      "PATH_CANNOT_BE_DELETED_DUE_TO_STEPS_ATTACHED": "Path cannot be deleted because there are steps attached to it",
      "PATH_CANNOT_BE_DELETED_DUE_TO_USER_PATHS_ATTACHED": "Path cannot be deleted because it has User Paths attached to it",
      "PATH_CANNOT_BE_DELETED_BECAUSE_PUBLISHED": "Path cannot be deleted because published"
    },
    "USER_STEP": {
      "INSUFFICIENT_RIGHT": "The user in the jwt should own the path whose step you want to modify.",
      "PROGRESS_DECREASING": "Progress can not decrease",
      "STEP_CANNOT_BE_DELETED_DUE_TO_USER_STEPS_ATTACHED": "Step cannot be deleted because there are user steps attached"
    },
    "UPLOAD": {
      "MAX_SIZE": "Uploaded file exceeds allowed limit ({{ MAX_SIZE }} MB)"
    },
    "COMPANY": {
      "COMPANY_NOT_FOUND_BY_REGISTRATION_CODE": "Company not found by registration code",
      "COMPANY_CANNOT_BE_DELETED_DUE_TO_USERS_ATTACHED": "The company cannot be deleted because it has users attached to it",
      "ERROR_DELETING_COMPANY": "There was an error deleting the company"
    },
    "DOWNLOAD": {
      "USER_ACTIONS": "User is not authorised to download file"
    },
    "STEP": {
      "ERROR_DELETING_STEP": "Error deleting Step",
      "THE_ID_PROVIDED_IS_NOT_A_VALID_ID_OF_A_CONTENT_OF_TYPE_AUDIO": "The id provided is not a valid id of a content of type audio",
      "THE_ID_PROVIDED_IS_NOT_A_VALID_ID_OF_A_CONTENT_OF_TYPE_VIDEO": "The id provided is not a valid id of a content of type video",
      "THE_CONTENT_OF_TYPE_TEXT_HAVING_ID_PROVIDED_COULD_NOT_BE_READ_FROM_THE_DATABASE": "The content of type text having id provided could not be read from the database",
      "THE_ID_PROVIDED_IS_NOT_A_VALID_ID_OF_AN_EXERCISE": "The id provided is not a valid id of an exercise",
      "THE_ID_PROVIDED_IS_FOR_A_CONTENT_THAT_IS_NOT_PUBLISHED": "The id provided is for a content that is not published",
      "THE_ID_PROVIDED_IS_NOT_A_VALID_ID_OF_A_SURVEY": "The id provided is not a valid id for a survey"
    }
  },
  "PAGINATOR": {
    "RANGE_ZERO": "0 of {{ length }}",
    "ITEMS_PER_PAGE": "Items per page",
    "NEXT_PAGE": "Next page",
    "PREVIOUS_PAGE": "Previous page",
    "RANGE": "{{ startIndex }} - {{endIndex }} of {{length }}"
  },
  "GRID": {
    "ADD_CHART": "Select a chart to add",
    "UNLOCK_GRID": "Unlock editing",
    "BAR_GRAPH": "Bar graph",
    "ARTICLES_PER_CATEGORY_PER_USER_RADAR": "Articles per category per user (radar chart)",
    "PIE_CHART": "Pie chart",
    "ARTICLES_PER_DAY_BAR": "Articles per day (bar chart)",
    "RADAR_CHART": "Radar chart",
    "LOCK_GRID": "Lock editing",
    "ARTICLES_PER_CATEGORY_PIE": "Articles per category (pie chart)",
    "DIALOG": {
      "TITLE": "Title"
    }
  },
  "NOTIFICATION": {
    "NO_NOTIFICATIONS": "You don't have any notifications",
    "ARTICLE": {
      "CREATED": "Article titled {{title}} has been created."
    },
    "COMMENT": {
      "ADDED": "User {{author}} has left a comment on your article titled {{title}}",
      "CHANGED": "Your comment has been {{changed}}!"
    }
  },
  "GENERAL_SETTINGS": {
    "EVENTS": {
      "CHOOSE_A_DATE": "Choose a date",
      "TO": "to",
      "TITLE": "Download logs",
      "DOWNLOAD": "Download",
      "DATE_IS_REQUIRED": "Date is required",
      "FROM": "From"
    },
    "VARIABLES": {
      "SUCCESS_BANNER": "Your changes were saved!",
      "UPDATE_VARIABLES_BUTTON": "Save changes",
      "TITLE": "Website variables"
    },
    "EXPORT_ACTIONS": "Export actions",
    "APP_VERSION": "Application version"
  },
  "COOKIES_MODAL": {
    "LABELS": {
      "NECESSARY": "Strictly necessary (ie. account login related cookies). They are required for the normal functioning of the website.",
      "TRACKING_AND_PERFORMANCE": "Tracking and performance (ie. Google Analytics)",
      "TARGETING_AND_ADVERTISING": "Targeting and advertising (ie. Google AdSense, Google AdWords)",
      "FUNCTIONALITY": "Functionality (ie. remembering users choices)"
    },
    "TABLE": {
      "NUMBER": "No.",
      "CATEGORY": "Category",
      "DOMAIN": "Domain",
      "LIFESPAN": "Lifespan",
      "NAME": "Name"
    },
    "BUTTON": {
      "SAVE": "Save settings",
      "ACCEPT_ALL": "Accept all cookies"
    },
    "DESCRIPTION_PARAGRAPH_1": "This site uses cookies. Cookies are files stored on your computer containing information shared between your internet browser and the internet website. The use of cookies accelerates and improves the use of internet websites. A cookie cannot read other information on your computer.",
    "DESCRIPTION_PARAGRAPH_2": "Please consult the \" help \" section of your internet browser or visit <a href=\"{{ link }}\" target=\"_blank\">aboutcookies.org</a> for more information on enabling and disabling cookies.",
    "SUBTITLE_CHOOSE_COOKIES": "You can choose the allowed cookies below:",
    "SUBTITLE_COOKIE_LIST": "Cookie list:",
    "TITLE": "Cookie settings"
  },
  "FOOTER": {
    "BUTTON": {
      "EDIT_COOKIE_SETTINGS": "Edit cookie settings",
      "COOKIE_SETTINGS": "Cookie settings",
      "ACCEPT_ALL": "Accept all cookies"
    },
    "COOKIE_NOTICE": "Before you continue using this website please read about our cookie policy"
  },
  "ADMIN": {
    "TABLE": {
      "USERS": {
        "COLUMNS": {
          "FIRST_NAME": "First name",
          "CLIENT": "Client",
          "EMAIL": "Email",
          "LAST_CONNECTION": "Last Connection",
          "ACTIVATION": "Activation",
          "ROLE": "Role",
          "LAST_NAME": "Last name",
          "COMPANY": "Company"
        },
        "FILTERS": {
          "EMAIL": "Email",
          "COMPANY": "Company",
          "FIRST_NAME": "First name",
          "LAST_NAME": "Last name",
          "PHONE": "Phone"
        },
        "ACTIONS": {
          "ACTIVATE": "Activate account",
          "BLOCK_USER": "Block user",
          "UNBLOCK_USER": "Unblock user",
          "DEACTIVATE": "Deactivate account"
        },
        "CONFIRMATION_DIALOG": {
          "DELETE_MULTIPLE": "Are you sure you want to delete {{ number }} users?",
          "DELETE": "Are you sure you want to delete this user?"
        },
        "DELETE_ITEM": "Remove",
        "BULK_ACTIONS": {
          "BLOCK_USERS": "Block user(s)",
          "UNBLOCK_USERS": "Unblock user(s)"
        },
        "SELECTED": "SELECTED",
        "DELETE": "DELETE",
        "TITLE": "Users",
        "EDIT": "Edit",
        "ADD": "Add new user",
        "ERRORS": {
          "CANNOT_DELETE": {
            "ENTITIES_REFER_TO_USER": "Cannot delete user, entities refer to it"
          }
        }
      },
      "ROLES": {
        "COLUMNS": {
          "COLOR": "Color",
          "NAME": "Name",
          "DESCRIPTION": "Description"
        },
        "DELETE_ITEM": "Remove",
        "TITLE": "Roles",
        "CONFIRMATION_DIALOG": {
          "DELETE": "Are you sure you want to delete this role?"
        },
        "ADD": "Add new role",
        "EDIT": "Edit",
        "ACTIONS": {
          "REMOVE": "Remove"
        }
      },
      "LABELS": {
        "COLUMNS": {
          "FR": "FR",
          "KEY": "Name",
          "SOURCE_LABEL": "Source label",
          "EN": "EN",
          "NL": "NL"
        },
        "FILTERS": {
          "KEY": "Key",
          "DEFAULT": "Source label",
          "VALUE": "Value"
        },
        "TITLE": "Labels"
      },
      "COMPANIES": {
        "TITLE": "Companies",
        "FILTERS": {
          "SUBSCRIPTION": "Subscription",
          "SUBSCRIPTION_END": "Subscription End",
          "NAME": "Name",
          "SUBSCRIPTION_START": "Subscription Start"
        },
        "COLUMNS": {
          "SUBSCRIPTION_START": "Subscription Start",
          "NAME": "Name",
          "SUBSCRIPTION": "Subscription",
          "SUBSCRIPTION_END": "Subscription End"
        },
        "DIALOG": {
          "NAME": "Name",
          "PLACEHOLDERS": {
            "NAME": "Name",
            "SUBSCRIPTION_END": "Subscription End",
            "REGISTRATION_CODE": "Registration Code",
            "DESCRIPTION": "Description",
            "SUBSCRIPTION_START": "Subscription Start",
            "CONTACT_PERSON": "Contact Person"
          },
          "ERRORS": {
            "DESCRIPTION_REQUIRED": "Please enter a description",
            "CONTACT_PERSON_REQUIRED": "Please enter Contact Person",
            "REGISTRATION_CODE_REQUIRED": "Please enter Registration Code",
            "SUBSCRIPTION_REQUIRED": "Please select subscription",
            "NAME_REQUIRED": "Please enter name"
          },
          "UPDATE_COMPANY": "Update Company",
          "SUBSCRIPTION_START": "Subscription Start",
          "CREATE_COMPANY": "Create Company",
          "SUBSCRIPTION_END": "Subscription End",
          "ASSISTANCE_INFO": "Assistance Info",
          "GENERAL_INFO": "General Info",
          "SUBSCRIPTION": "Subscription"
        },
        "EDIT": "Edit",
        "DELETE_ITEM": "Remove",
        "ADD": "Add new company",
        "CONFIRMATION_DIALOG": {
          "DELETE": "Are you sure you want to Delete the Company ?"
        }
      },
      "PATHS": {
        "FILTERS": {
          "TITLE": "Title",
          "DURATION": "Duration",
          "DIFFICULTY": "Difficulty",
          "SHORT_DESCRIPTION": "Short Description"
        },
        "DIALOG": {
          "UPDATE_PATH": "Update Path",
          "LONG_DESCRIPTION": "Long description",
          "PUBLISHED_TRUE": "true",
          "GENERAL_INFO": "General info",
          "DIFFICULTY": "Difficulty",
          "PLACEHOLDERS": {
            "DURATION": "Duration"
          },
          "TITLE": "Title",
          "IMAGE": "Image",
          "SHORT_DESCRIPTION": "Short description",
          "PUBLISHED": "Published",
          "CREATE_PATH": "Create Path",
          "THEME": "Theme",
          "PUBLISHED_FALSE": "false",
          "WEIGHT": "Weight"
        },
        "ACTIONS": {
          "STEPS": "Manage Steps",
          "PUBLISH": "Publish",
          "UNPUBLISH": "Unpublish"
        },
        "TITLE": "Paths",
        "ADD": "Add Path",
        "EDIT": "Edit Path",
        "COLUMNS": {
          "PUBLISHED": "Published"
        },
        "DELETE_ITEM": "Delete",
        "CONFIRMATION_DIALOG": {
          "DELETE": "Do you want to delete the path ?"
        }
      },
      "STEPS": {
        "TITLE": "Manage Steps",
        "DIALOG": {
          "SHORT_DESCRIPTION": "Short Description",
          "PLACEHOLDERS": {
            "EXERCISE_ID": "Exercise Id",
            "DURATION": "Duration",
            "ORDER": "Order",
            "CONTENT_TEXT_ID": "Text Content Id",
            "CONTENT_AUDIO_ID": "Audio Content Id",
            "CONTENT_VIDEO_ID": "Video Content Id",
            "SURVEY_ID": "Survey Id"
          },
          "CREATE_STEP": "Create Step",
          "GENERAL_INFO": "General info",
          "CONTENT_TYPE": "Content Type",
          "TITLE": "Title",
          "LONG_DESCRIPTION": "Long Description",
          "UPDATE_STEP": "Update Step",
          "ERRORS": {
            "CONTENT_TEXT_REQUIRED": "Text Content Required",
            "EXERCISE_REQUIRED": "Exercise Required",
            "CONTENT_AUDIO_REQUIRED": "Audio Content Required",
            "CONTENT_VIDEO_REQUIRED": "Video Content Required",
            "SURVEY_REQUIRED": "Survey Required"
          }
        },
        "ADD": "Add Step",
        "FILTERS": {
          "SHORT_DESCRIPTION": "Short Description",
          "CONTENT_TYPE": "Content Type",
          "CONTENT_TITLE": "Content Title",
          "TITLE": "Title"
        },
        "EDIT": "Edit Step",
        "DELETE_ITEM": "Delete Step",
        "STEPS_OF_PATH": "of path {{pathTitle}}",
        "CONFIRMATION_DIALOG": {
          "DELETE": "Are you sure you want to delete the step ?"
        },
        "ACTIONS": {
          "MOVE_DOWN": "Move down",
          "MOVE_UP": "Move up"
        },
        "COLUMNS": {
          "ORDER": "Order"
        }
      },
      "CONTENT": {
        "ADD": "Add new content",
        "FILTERS": {
          "TITLE": "Title",
          "TYPE": "Type",
          "ID": "Id"
        },
        "COLUMNS": {
          "IMAGE": "Image",
          "TITLE": "Title",
          "SHORT_DESCRIPTION": "Short description",
          "ESTIMATED_TIME": "Estimated Time",
          "TYPE": "Type",
          "PUBLISHED": "Published"
        },
        "DIALOG": {
          "SHORT_DESCRIPTION": "Short description",
          "TEXT_CONTENT": "Text content",
          "PLACEHOLDERS": {
            "TITLE": "Title",
            "LONG_DESCRIPTION": "Long description",
            "TEXT_CONTENT": "Text content",
            "ESTIMATED_TIME": "Estimated Time",
            "SHORT_DESCRIPTION": "Short description"
          },
          "ERRORS": {
            "TITLE_REQUIRED": "Please enter a title",
            "CONTACT_PERSON_REQUIRED": "Please enter Contact Person",
            "REGISTRATION_CODE_REQUIRED": "Please enter Registration Code",
            "DESCRIPTION_REQUIRED": "Please enter a description",
            "TYPE_REQUIRED": "Please choose a type"
          },
          "UPDATE_CONTENT": "Update Content",
          "TYPE": "Type",
          "TRANSCRIPT": "Transcript",
          "CREATE_CONTENT": "Create Content",
          "PUBLISHED": "Published",
          "GENERAL_INFO": "General Info",
          "TITLE": "Title",
          "IMAGE": "Image",
          "SINGLE_LANGUAGE_FIELDS": "Single language fields",
          "LONG_DESCRIPTION": "Long description",
          "FILE_CONTENT": "File content"
        },
        "PUBLISHED_TYPE": {
          "YES": "Yes",
          "NO": "No"
        },
        "DELETE_ITEM": "Remove",
        "TYPE": {
          "TEXT": "Text",
          "AUDIO": "Audio",
          "VIDEO": "Video"
        },
        "TITLE": "Content",
        "EDIT": "Edit"
      },
      "CUSTOMERS": {
        "TITLE": "Customers",
        "COLUMNS": {
          "ADDRESS": "Address",
          "CITY": "City",
          "ZIP_CODE": "Zip code",
          "NAME": "Name",
          "ODOO_ID": "Odoo ID",
          "PHONE": "Phone"
        },
        "FILTERS": {
          "NAME": "Name",
          "ODOO_ID": "Odoo ID",
          "PHONE": "Phone",
          "CITY": "City",
          "ZIP_CODE": "Zip code",
          "ADDRESS": "Address"
        },
        "DIALOG": {
          "ADDRESS": "Address",
          "LONGITUDE": "Longitude",
          "ERRORS": {
            "PHONE_REQUIRED": "Phone is required",
            "PREFERRED_LANGUAGE_REQUIRED": "Preferred Language is required",
            "ZIP_CODE_REQUIRED": "Zip code is required",
            "NAME_REQUIRED": "Name is required",
            "LATITUDE_REQUIRED": "Latitude is required",
            "ADDRESS_REQUIRED": "Address is required",
            "LONGITUDE_REQUIRED": "Longitude is required",
            "CITY_REQUIRED": "City is required"
          },
          "CITY": "City",
          "PREFERRED_LANGUAGE": "Preferred Language",
          "ZIP_CODE": "Zip code",
          "NAME": "Name",
          "LATITUDE": "Latitude",
          "PHONE": "Phone",
          "ODOO_ID": "Odoo ID"
        },
        "DELETE_ITEM": "Delete this customer",
        "DELETE": "DELETE",
        "EDIT": "Edit this customer",
        "CONFIRMATION_DIALOG": {
          "DELETE": "Delete customer?"
        },
        "ADD": "Create new customer",
        "SELECTED": "SELECTED"
      },
      "THEMES": {
        "DIALOG": {
          "NAME": "Name",
          "LONGDESCRIPTION": "Long Description",
          "IMAGE": "Image",
          "COLOR": "Color",
          "SHORTDESCRIPTION": "Short Description"
        },
        "COLUMNS": {
          "IMAGE": "Image",
          "FR": "FR",
          "NL": "NL",
          "EN": "EN"
        },
        "ADD": "New Theme",
        "DELETE_ITEM": "Delete Theme",
        "EDIT": "Edit this theme",
        "TITLE": "Themes"
      },
      "EXERCICES": {
        "ADD": "New Exercice",
        "DIALOG": {
          "LONG_DESCRIPTION": "Long Description",
          "PLACEHOLDERS": {
            "LONG_DESCRIPTION": "Long Description",
            "TITLE": "Title",
            "SHORT_DESCRIPTION": "Short Description",
            "REINFORCEMENT_MESSAGE": "Reinforcement Message"
          },
          "ERRORS": {
            "SHORT_DESCRIPTION_LENGTH": "Short Description must be between 3 and 200 characters.",
            "TITLE_REQUIRED": "Title in every language is required.",
            "TITLE_LENGTH": "Title must be between 3 and 50 characters.",
            "SHORT_DESCRIPTION_REQUIRED": "Short Description in every language is required."
          },
          "CREATE_EXERCICE": "Create Exercice",
          "ACTIONS": {
            "UNPUBLISH": "Unpublish",
            "PUBLISH": "Publish"
          },
          "TITLE": "Title",
          "SHORT_DESCRIPTION": "Short Description",
          "UPDATE_EXERCICE": "Update Exercice"
        },
        "COLUMNS": {
          "LONG_DESCRIPTION": "Long Description",
          "PUBLISHED": "Published",
          "TITLE": "Title",
          "SHORT_DESCRIPTION": "Short Description",
          "REINFORCEMENT_MESSAGE": "Reinforcement Message"
        },
        "FILTERS": {
          "SHORT_DESCRIPTION": "Short Description",
          "REINFORCEMENT_MESSAGE": "Reinforcement Message",
          "ID": "ID",
          "PUBLISHED": "Published",
          "TITLE": "Title",
          "LONG_DESCRIPTION": "Long Description"
        },
        "EDIT": "Edit this exercice",
        "TITLE": "Exercices",
        "DELETE_ITEM": "Delete Exercice"
      },
      "STATIC_PAGES": {
        "COLUMNS": {
          "TITLE": "Title",
          "TRANSLATIONS": "Translations",
          "LINK": "Link"
        },
        "ADD": "Add new static page",
        "TITLE": "Static pages"
      },
      "STATIC_CONTENT": {
        "COLUMNS": {
          "TITLE": "Title"
        },
        "TITLE": "Static content"
      },
      "GENERAL_SEARCH": "Search",
      "ERRORS": {
        "NO_RESULTS": "NO MATCHING SEARCH RESULTS",
        "TRY_AGAIN": "Try again using more general search terms",
        "NO_COLLECTION": "NO MATCHING SEARCH RESULTS"
      },
      "DEFAULT_COLUMNS": {
        "ACTIONS": "Actions"
      },
      "QUESTIONS": {
        "TITLE": "Questions",
        "ADD": "Add new question",
        "EDIT": "Edit",
        "DELETE_ITEM": "Remove",
        "FILTERS": {
          "ORDER": "Order of questions"
        },
        "ACTIONS": {
          "MOVE_UP": "Move up",
          "MOVE_DOWN": "Move down"
        },
        "COLUMNS": {
          "QUESTION": "Question",
          "DESCRIPTION": "Description",
          "SKIPPABLE": "Skippable?",
          "REDFLAG": "Redflag?",
          "TYPE": "Type",
          "ORDER": "Order"
        },
        "DIALOG": {
          "UPDATE_QUESTION": "Update Question",
          "CREATE_QUESTION": "Create Question",
          "PLACEHOLDERS": {
            "QUESTION": "Question",
            "DESCRIPTION": "Description",
            "TYPE": "Type"
          },
          "ERRORS": {
            "QUESTION_LENGTH": "The question should be between 3 and 50 characters.",
            "DESCRIPTION_LENGTH": "The question should be between 3 and 200 characters.",
            "TYPE_REQUIRED": "You must select a type for the question"
          }
        },
        "CONFIRMATION_DIALOG": {
          "DELETE": "Are you sure you want to Delete the Company ?"
        },
        "QUESTIONS_OF_SURVEY": "of survey"
      }
    },
    "DIALOG": {
      "NAVIGATOR": {
        "NON_TRANSLATABLE": "Single language",
        "TRANSLATABLE": "Translatable"
      }
    }
  },
  "IMPORTS": {
    "FILE_TYPE": "File must be .xlsx! Please try another one.",
    "CLIENTS": "Upload xlsx file to import clients",
    "PRODUCTS": "Upload xlsx file to import products",
    "RESPONSE": "Import from '{{ fileName }}' ({{ total }} records):\n      <br> &nbsp;&nbsp;&nbsp; - {{successful}} successful,\n      <br> &nbsp;&nbsp;&nbsp; - {{ duplicates }} duplicate(s),\n      <br> &nbsp;&nbsp;&nbsp; - {{ invalid }} invalid"
  },
  "PAGE_TITLE": {
    "MANAGE_EXERCICES": "Manage Exercices",
    "LOGIN": "Login",
    "MANAGE_PATHS": "Manage Paths",
    "MANAGE_USERS": "Manage users",
    "MANAGE_ROLES": "Manage roles",
    "MANAGE_THEMES": "Manage Themes",
    "HOME": "Home",
    "MANAGE_LABELS": "Manage labels",
    "MANAGE_COMPANIES": "Manage Companies"
  },
  "AUTOCOMPLETE": {
    "ERROR_REQUIRED": "Field is required"
  },
  "LIST_LABELS": {
    "LABEL_DIALOG": {
      "KEY": "Key",
      "DEFAULT": "Default",
      "TITLE": "Update Label"
    }
  },
  "PROJECT": {
    "ALT_IMAGES": {
      "LOGO": "project logo"
    }
  },
  "APP": {
    "SKIP_LINK": {
      "TEXT": "Jump directly to main content"
    }
  },
  "ABOUT_US": {
    "TITLE": "About us...",
    "CONTENT": "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout and it will\n         not reach the end of file"
  },
  "ERROR_PAGE": {
    "BACK_BUTTON": "Go back to homepage"
  },
  "DATA_REPORT": {
    "NO_DATA_URL": "Oups, data studio url not provided! "
  }
}